import React, { useCallback, useEffect, useRef, useState } from "react";

import { IonIcon, IonSelect, IonSelectOption, useIonToast } from "@ionic/react";
import { chevronDown } from "ionicons/icons";

import classNames from "classnames/bind";
import styles from "./SelectShippingZone.module.scss";

import { useActiveOrMainShippingZone } from "../../providers/shippingZones";
import { ShippingZonesModalWidget } from "../../widgets/ShippingZonesModalWidget/ShippingZonesModalWidget";
import { useConfig } from "../../providers/config";
import { useGetShippingZonesQuery } from "../../providers/shippingAndPayment";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

interface SelectShippingZoneProps {
  interfaceType?: "action-sheet" | "popover";
}

const SelectShippingZone = ({ interfaceType = "action-sheet" }: SelectShippingZoneProps) => {
  const [presentToast] = useIonToast();
  const selectRef = useRef<HTMLIonSelectElement>(null);
  const { t } = useTranslation();
  const [isModalOpened, setIsModalOpened] = useState(false);

  const { activeShippingZone } = useActiveOrMainShippingZone();

  const openModal = () => {
    setIsModalOpened(true);
    selectRef!.current?.click();
  };

  const config = useConfig();

  const presentErrorToast = useCallback(
    (err: string) => {
      presentToast({
        message: err ?? t("unexpectedErrorShippingZones"),
        duration: 2000,
        color: "danger",
      });
    },
    [presentToast],
  );

  const { data: shippingZones } = useGetShippingZonesQuery({
    onError: presentErrorToast,
    enabled: config?.shipping.isShippingZonesEnabled && config?.shipping.showDefaultShippingZone,
  });

  return (
    <>
      <span onClick={openModal} className={cx("shippingZone flex items-center justify-center cursor-pointer")}>
        {interfaceType === "action-sheet" && (
          <>
            <span className={cx("shippingZone__name")}>{activeShippingZone?.name}</span>
            <IonIcon className={cx("icon-12")} icon={chevronDown} />
            {isModalOpened ? <ShippingZonesModalWidget setIsModalOpened={setIsModalOpened} /> : null}
          </>
        )}
        {interfaceType === "popover" && !!shippingZones && (
          <>
            <IonSelect
              ref={selectRef}
              value={activeShippingZone?.id}
              className={cx("shippingZone__select")}
              onIonChange={(e) => {
                const zone = shippingZones!.find((_zone) => _zone.id === e.detail.value);
                // setShippingZone(zone);
              }}
              interface={"popover"}
            >
              {shippingZones?.map((zone) => (
                <IonSelectOption key={zone.id} value={zone.id}>
                  {zone.name}
                </IonSelectOption>
              ))}
            </IonSelect>
            <IonIcon className={cx("icon-10")} icon={chevronDown} />
          </>
        )}
      </span>
    </>
  );
};

export { SelectShippingZone };
